
const SELECTOR = {
    ROOT: 'js-popover',
    BUTTON: 'js-popover-button',
};

function init() {
    const root = $(`.${SELECTOR.ROOT}`);
    const button = $(`.${SELECTOR.BUTTON}`, root);

    button.on('click', function () {
        $(this).parent().toggleClass("--active");
    });
}

if ($(`.${SELECTOR.ROOT}`).length > 0 && $(`.${SELECTOR.BUTTON}`).length > 0) {
    init();
}


// WEBPACK FOOTER //
// ./_layout/js/__popover.js